<template>
    <v-dialog
      v-model="dialog"
      scrollable
      max-width="600px"
      transition="dialog-bottom-transition"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn color="success" v-bind="attrs" v-on="on">
          <v-icon class="mr-1" dense>
            mdi-paperclip
          </v-icon>
            Comprovantes
        </v-btn>
      </template>
      <v-card>

        <v-overlay
          :absolute="true"
          :value="loadingFile"
          z-index="10"
        >
          <v-progress-circular
            v-show="loadingFile"
            :size="50"
            color="success"
            indeterminate
          >
          </v-progress-circular>

        </v-overlay>

        <v-card-title>
          <div class="filezone">
            <input type="file" id="files" multiple @change="handleFiles"/>
            <p>Arraste aqui <br>ou clique para procurar</p>
          </div>
        </v-card-title>

        <v-card-text>

          <v-list
            subheader
            two-line
          >
            <v-list-item
              v-for="(file, index) in $v.files.$each.$iter"
              :key="file.hash.$model"
            >
              <v-list-item-avatar class="py-0 my-0">
                <!-- <v-icon class="grey lighten-1" dark> mdi-file </v-icon> -->
                <v-img
                  :src="file.preview.$model"
                  :src-lazy="file.preview.$model"
                  class="grey lighten-2"
                > </v-img>
              </v-list-item-avatar>

              <!-- nome do arquivo -->
              <v-list-item-content class="py-0 my-0 ml-0 mr-2">
                <v-text-field
                  v-model="file.nome.$model"
                  v-remove-acentos="'uppercase'"
                  class="mx-2"
                  v-show="!file.isUploading.$model && !file.loading.$model"
                  :error-messages="validacaoForm(file.nome, 'Arquivo')"
                  @blur="alteraNome($event, file.$model, file)"
                >
                </v-text-field>

                <v-progress-linear
                  v-show="file.isUploading.$model"
                  v-model="file.progressFile.$model"
                  height="25"
                >
                  <strong> {{ file.progressFile.$model }} </strong>
                </v-progress-linear>

                <v-progress-linear
                  v-show="file.loading.$model && !file.isUploading.$model"
                  height="10"
                  indeterminate
                  rounded
                >
                  {{ file.textLoading.$model ? file.textLoading.$model : null }}
                </v-progress-linear>

              </v-list-item-content>

                <!-- botão download -->
                <v-btn icon v-if="file.id.$model && !file.isPromisse.$model && !file.loading.$model">
                  <v-icon color="success" @click="downloadURL(file.$model)"> mdi-cloud-download </v-icon>
                </v-btn>

                <!-- botão upload -->
                <v-btn icon v-if="!file.id.$model && !file.isPromisse.$model && !file.loading.$model">
                  <v-icon color="success" @click="sendFile(file.$model, index, file)">mdi-upload</v-icon>
                </v-btn>

                <!-- botão excluir -->
                <v-btn icon v-if="!file.isPromisse.$model && !file.loading.$model">
                  <v-icon color="red" @click="removeFile(file.$model, index)" >mdi-close-circle</v-icon>
                </v-btn>
            </v-list-item>

            <v-divider inset v-show="files && files.length"></v-divider>

          </v-list>

          <v-divider></v-divider>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="success darken-1"
            text
            @click="fechar()"
          >
            Voltar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>

import { mapActions, mapState } from 'vuex'
import validacaoForm from '@/mixins/validacaoForm'
import {required, minLength, maxLength} from 'vuelidate/lib/validators'

export default {
  props: {
    processo_id: {
      type: Number,
      required: true
    }
  },
  mixins: [validacaoForm],
  data () {
    return {
      dialog: false,
      loadingFile: false,
      chave_id: 'processo_id',
      origin: 'pagamentos'
    }
  },
  validations: {
    files: {
      $each: {
        id: { errors: [] },
        nome: {required, minLength: minLength(2), maxLength: maxLength(60), errors: [] },
        preview: { errors: [] },
        isPromisse: { errors: [] },
        loading: { errors: [] },
        textLoading: { errors: [] },
        isUploading: { errors: [] },
        progressFile: { errors: [] },
        preview: { errors: [] },
        hash: { errors: [] },
      }
    }
  },
  watch: {
    files(novo) {
      let filtered = novo.filter(el => el.processo_id && el.processo_id == this.processo_id && origin == this.origin )
      return JSON.parse(JSON.stringify(filtered))
    }
  },
  created() {
    this.buscarArquivos()
  },
  updated(){
    // console.log('Passou pelo updated')
  },
  methods: {
    ...mapActions({
      handleFilesStore: 'orquestraFiles/HANDLE_FILES',
      deleteFileStore: 'orquestraFiles/DELETE_FILE',
      sendFileStore: 'orquestraFiles/SEND_FILE',
      getFilesStore: 'orquestraFiles/GET_FILES',
      updateFileStore: 'orquestraFiles/UPDATE_FILE',
      downloadFileStore: 'orquestraFiles/DOWNLOAD_FILE'
    }),
    async alteraNome(event, file, fileModel) {
      if (!this.validateFile(fileModel)) return
      let url = `filepagamento/${this.processo_id}`
      try {
        await this.updateFileStore({file, url, chave_id: this.chave_id, value: this.processo_id, origin: this.origin})
      } catch (error) {
        this.$toaster.error(error)
        console.log('erro alteraNome', error)
      } finally {
        file.loading = false
      }
    },
    validateFile(file) {
      if (file.$anyError) {
        this.$toaster.error('Erro no arquivo. Verifique.')
        return false
      }
      return true
    },
    fechar () {
      this.dialog = false
    },
    async handleFiles(event) {
      this.loadingFile = true
      let uploadedFiles = event.target.files
      for(var i = 0; i < uploadedFiles.length; i++) {
        try {
          await this.handleFilesStore({file: uploadedFiles[i], chave_id: this.chave_id, value: this.processo_id, origin: this.origin})
        } catch (error) {
          this.$toaster.error(error)
          console.log(error)
        }
      }
      event.target.files = null
      event.target.value = null
      setTimeout(() => {
        this.loadingFile = false
      }, 3000);
      return

    },

    async buscarArquivos() {
      this.loadingFile = true
      try {
        await this.getFilesStore({url: 'filepagamento/files', chave_id: this.chave_id, value: this.processo_id, origin: this.origin})        
      } catch (error) {
        this.$toaster.error(`Erro ao buscar arquivos`)
        console.log(error)
      } finally {
        this.loadingFile = false
      }
      /*.then(res => {})
      .catch(error => {
        this.$toaster.error(`Erro ao buscar arquivos`)
        console.log(error)
      })
      .finally(() => this.loadingFile = false)*/
    },

    async sendFile(file, index, fileModel){
      if (!this.validateFile(fileModel)) return
      file.isErro = false
      file.isPromisse = true
      file.isPromisseSend = true
      this.sendFileStore({file, index, url: 'filepagamento', chave_id: this.chave_id, value: this.processo_id, origin: this.origin})
      .then(resp => {})
      .catch ((err) => {
        file.isErro = true
      })
      .finally(() => {
        file.downloadFile = false
        file.loading = false
        file.isUploading = false
        file.isPromisse  = false
        file.isPromisseSend = false
      })
    },

    async removeFile(file, index) {
      if (file.isPromisse) return
      this.$dialog.confirm("Após excluído, arquivo não pode ser recuperados. Deseja continuar?", {loader: true, okText: 'Sim', cancelText: 'Não',})
      .then(async (dialog) => {
        file.isPromisse = true
        file.loading = true
        try {
          await this.deleteFileStore({file, url: 'filepagamento', chave_id: this.chave_id, value: this.processo_id, origin: this.origin})
        } catch (error) {
          this.$toaster.error('Erro ao excluir Arquivo')
        } finally {
          file.loading = false
          file.isPromisse = false
          dialog.close()
        }
      })
      .catch((e) => {})

    },

    async downloadURL(file) {
      try {
        await this.downloadFileStore({file, url: 'filepagamento/download'})
        this.$toaster.success('Efetuando Download. Aguarde...')
      } catch (error) {
        this.$toaster.error(error)
      }
    }
  },
  computed: {
    ...mapState('orquestraFiles', [
      'files'
    ]),
  }
}

</script>
<style scoped>
  input[type="file"]{
        opacity: 0;
        width: 100%;
        height: 70px;
        max-height: 70px;
        position: absolute;
        cursor: pointer;
    }
    .filezone {
        width: 100%;
        outline: 2px dashed grey;
        outline-offset: -10px;
        background: #ccc;
        color: dimgray;
        padding: 10px 10px;
        min-height: 100px;
        max-height: 100px;
        position: relative;
        cursor: pointer;
    }
    .filezone:hover {
        background: #c0c0c0;
    }

    .filezone p {
        font-size: 1.2em;
        text-align: center;
        padding: 20px;
    }

    #noboxshadow {
      box-shadow: none !important;
    }
</style>



// WEBPACK FOOTER //
// src/views/OrquestraFiles/FilesView.vue